import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { Text } from "sprout-ui-primitives";
import { Button as BaseButton } from "sprout-ui-dom";
import styled from "styled-components";
import { KeyboardArrowDown } from "sprout-ui-icons";
import { themeGet } from "sprout-ui-theme";
const Button = styled(BaseButton)`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 24px;
  padding: 0 8px;
  margin-bottom: 4px;

  button + &,
  ul + & {
    margin-top: 12px;
  }
`;
const StyledKeyboardArrowDown = styled(KeyboardArrowDown)`
  /* color: ${themeGet("colors.blue.40")}; */
  color: #ffd953;
  transition: transform 0.2s ease;

  ${({ $expand  })=>$expand && `transform: rotate(-180deg);`}
`;
const JumpToGroupExpandButton = (props)=>{
    const { title , onClick , isExpanded , disabled  } = props;
    const handleClick = useCallback((event)=>{
        event.stopPropagation();
        onClick(event);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ _jsxs(Button, {
        onClick: handleClick,
        disabled: disabled,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                as: "span",
                caps: true,
                color: "#FFD953",
                fontSize: 1,
                fontWeight: "bold",
                children: title
            }),
            /*#__PURE__*/ _jsx(StyledKeyboardArrowDown, {
                $expand: isExpanded
            })
        ]
    });
};
export default JumpToGroupExpandButton;
